import { palette } from './palette';
import HeaderLogo from '../assets/images/header-logo.svg';
import ChevronRight from '../assets/images/chevron-right.svg';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
    '& .login-back-button': {
      color: `${palette.text.primary} !important`,
    },
    '& .MuiFormLabel-root, & .MuiInputLabel-root': {
      '&.Mui-focused': {
        color: `${palette.text.primary} !important`,
      },
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused .MuiOutlinedInput-notchedOutline, &.Mui-focused fieldset': {
        borderColor: `${palette.text.primary} !important`,
      },
      '&:hover .MuiOutlinedInput-notchedOutline, &:hover fieldset': {
        borderColor: `${palette.text.primary} !important`,
      },
    },
    '& .MuiButton-containedPrimary, & button[type="submit"]': {
      border: 'none !important',
      color: `${palette.text.highlight} !important`,
      '& .MuiButton-label': {
        color: `${palette.text.highlight} !important`,
      },
      '&:hover': {
        border: 'none !important',
        color: `${palette.text.highlight} !important`,
      },
    },
    '& .MuiTypography-colorPrimary, & .MuiButton-textPrimary, & .signin-other-link, & .signin-other-link .MuiButton-label': {
      color: `${palette.text.primary} !important`,
    },
  },

  /* Inner pages + scrolled home: pricing cream header. Home hero (unscrolled) overrides below. */
  '.header-wrapper': {
    background: `${palette.surface.pricing} !important`,
    borderBottom: `1px solid ${palette.background.headerBorder} !important`,
    boxShadow: 'none !important',
    color: `${palette.text.nav} !important`,
    padding: '0 80px',
    height: '155px',
    minHeight: '155px',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1200,
    display: 'flex',
    alignItems: 'center',
    transition: 'background 0.2s ease',
    '@media(max-width: 1024px)': {
      padding: '0 24px',
      height: '96px',
      minHeight: '96px',
    },
    '& .MuiToolbar-root': {
      minHeight: '155px !important',
      height: '155px',
      width: '100%',
      paddingLeft: '0 !important',
      paddingRight: '0 !important',
      alignItems: 'center',
      '@media(max-width: 1024px)': {
        minHeight: '96px !important',
        height: '96px',
      },
    },
    '& .top-bar-logo-container': {
      height: '108px !important',
      maxHeight: '108px !important',
      width: 'auto !important',
      minWidth: '284px !important',
      maxWidth: 'none !important',
      flexShrink: '0 !important',
      display: 'flex !important',
      alignItems: 'center !important',
      justifyContent: 'flex-start',
      overflow: 'visible !important',
      color: `${palette.text.nav} !important`,
      '@media(max-width: 1024px)': {
        height: '64px !important',
        maxHeight: '64px !important',
        minWidth: '168px !important',
      },
      '& a, & .MuiLink-root': {
        display: 'inline-flex !important',
        alignItems: 'center !important',
        height: '100% !important',
        maxHeight: '100% !important',
        width: 'auto !important',
        maxWidth: 'none !important',
        overflow: 'visible !important',
        position: 'relative',
        color: `${palette.text.nav} !important`,
        '&::after': {
          content: '""',
          position: 'absolute',
          left: 0,
          top: 0,
          width: '100%',
          height: '100%',
          backgroundImage: `url(${HeaderLogo})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'left center',
          backgroundSize: 'contain',
          pointerEvents: 'none',
        },
      },
      '& img, & .image': {
        height: '108px !important',
        maxHeight: '108px !important',
        width: 'auto !important',
        maxWidth: 'none !important',
        objectFit: 'contain !important',
        display: 'block !important',
        opacity: '0 !important',
        '@media(max-width: 1024px)': {
          height: '64px !important',
          maxHeight: '64px !important',
        },
      },
      '& .MuiTypography-root, & span': {
        color: `${palette.text.nav} !important`,
      },
    },
    '& .topbar-listitem, & .topbar-listitem .menu-item, & .topbar-listitem .MuiTypography-root, & .topbar-listitem .MuiTypography-colorInherit, & .topbar-listitem .MuiButton-root, & .topbar-listitem .MuiButton-label, & .topbar-listitem .MuiButton-text, & .listLink, & .menu-item, & a.MuiTypography-root, & .MuiTypography-colorPrimary, & .MuiButton-text': {
      color: `${palette.text.nav} !important`,
      textTransform: 'uppercase !important',
      fontSize: '16px !important',
      fontWeight: 500,
      letterSpacing: '0.8px !important',
      fontFamily: 'InterDisplay-Regular !important',
      lineHeight: '1.5 !important',
    },
    '& .header-phone-link': {
      display: 'none !important',
    },
    '& .topbar-signup-cta, & .topbar-signup-cta.MuiButton-root, & .topbar-signup-cta .MuiButton-label, & .topbar-signup-cta .MuiTypography-root, & [data-testid="topbar-logout-button"], & .topbar-logout-button .MuiButton-root': {
      minHeight: '40px',
      minWidth: 'unset',
      padding: '8px 16px !important',
      fontSize: '16px !important',
      fontWeight: 500,
      fontFamily: 'InterDisplay-Regular !important',
      textTransform: 'uppercase !important',
      letterSpacing: '0.8px !important',
      lineHeight: '1.5 !important',
      backgroundColor: `${palette.primary.main} !important`,
      color: `${palette.surface.pricing} !important`,
      border: 'none !important',
      borderRadius: '0 !important',
      boxShadow: 'none !important',
      '&:hover': {
        backgroundColor: `${palette.primary.main} !important`,
        color: `${palette.surface.pricing} !important`,
        border: 'none !important',
        opacity: 0.92,
      },
    },
    /* Figma: Get Started + right chevron */
    '& .topbar-signup-cta.MuiButton-root, & .topbar-signup-cta': {
      '& .MuiButton-label': {
        display: 'inline-flex !important',
        alignItems: 'center !important',
        gap: '8px !important',
        '&::after': {
          content: '""',
          display: 'inline-block',
          width: '24px',
          height: '24px',
          flexShrink: 0,
          backgroundImage: `url(${ChevronRight})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: '24px 24px',
        },
      },
    },
  },

  /* Home hero only (not scrolled, desktop): transparent header over image.
     Mobile/tablet always keep the scrolled (pricing + dark logo) header. */
  'body:has(.home-hero-wrapper) .header-wrapper:not(.active-header)': {
    '@media(min-width: 1025px)': {
      background: 'transparent !important',
      borderBottom: 'none !important',
      color: `${palette.text.highlight} !important`,
      '& .top-bar-logo-container, & .top-bar-logo-container .MuiTypography-root, & .top-bar-logo-container span, & .top-bar-logo-container a, & .top-bar-logo-container .MuiLink-root': {
        color: `${palette.text.highlight} !important`,
      },
      '& .top-bar-logo-container a::after, & .top-bar-logo-container .MuiLink-root::after': {
        content: 'none !important',
        display: 'none !important',
      },
      '& .top-bar-logo-container img, & .top-bar-logo-container .image': {
        opacity: '1 !important',
      },
      '& .topbar-listitem, & .topbar-listitem .menu-item, & .topbar-listitem .MuiTypography-root, & .topbar-listitem .MuiTypography-colorInherit, & .topbar-listitem .MuiButton-root, & .topbar-listitem .MuiButton-label, & .topbar-listitem .MuiButton-text, & .listLink, & .menu-item, & a.MuiTypography-root, & .MuiTypography-colorPrimary, & .MuiButton-text': {
        color: `${palette.text.highlight} !important`,
      },
      '& .topbar-signup-cta, & .topbar-signup-cta.MuiButton-root, & .topbar-signup-cta .MuiButton-label, & .topbar-signup-cta .MuiTypography-root, & [data-testid="topbar-logout-button"], & .topbar-logout-button .MuiButton-root': {
        backgroundColor: `${palette.primary.main} !important`,
        color: `${palette.text.highlight} !important`,
        '&:hover': {
          backgroundColor: `${palette.primary.main} !important`,
          color: `${palette.text.highlight} !important`,
        },
      },
    },
  },

  '.group-parent-container': {
    '& .home-static-hero-wrapper': {
      '& .MuiButton-containedPrimary, & .primary-static-button': {
        backgroundColor: `${palette.primary.main} !important`,
        color: `${palette.text.highlight} !important`,
        border: 'none !important',
        fontSize: '18px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 500,
        fontFamily: 'InterDisplay-Regular !important',
        textTransform: 'uppercase !important',
        padding: '16px 24px !important',
        boxShadow: 'none !important',
        borderRadius: '0 !important',
        '&:hover': {
          backgroundColor: `${palette.primary.main} !important`,
          color: `${palette.text.highlight} !important`,
          border: 'none !important',
          opacity: 0.92,
          boxShadow: 'none !important',
        },
      },
    },
    '& .normal-text': {
      fontWeight: 400,
      fontFamily: 'NeueMontreal-Medium !important',
      fontSize: '64px !important',
      lineHeight: '72px !important',
      letterSpacing: '-0.64px !important',
      '@media (min-width: 600px) and (max-width: 1024px)': {
        fontSize: '52px !important',
        lineHeight: '64px !important',
        letterSpacing: '-1.04px !important',
      },
      '@media (max-width: 600px)': {
        fontSize: '44px !important',
        lineHeight: '48px !important',
        letterSpacing: '-0.88px !important',
      },
    },
    '& .savings-hero-section, & .checkout-hero-section, & .plan-selection-section, & .faq-hero-section, & .dashboard-hero-section, & .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
    {
      marginTop: 155,
      background: `${palette.surface.pricing} !important`,
      '@media(max-width: 1024px)': {
        marginTop: 96,
      },
      backgroundImage: 'none !important',
      backgroundSize: 'unset !important',
      borderBottom: `1px solid ${palette.background.footer}`,
      maxHeight: 'none !important',
      marginBottom: '0 !important',
      overflow: 'hidden',
      '& > .section, & > section': {
        background: `${palette.surface.pricing} !important`,
        padding: '80px !important',
        maxWidth: 'none !important',
        margin: '0 !important',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '32px',
        '@media(max-width: 1024px)': {
          padding: '64px 40px !important',
        },
        '@media(max-width: 600px)': {
          padding: '48px 20px !important',
          gap: '24px',
        },
      },
      '& .section-header': {
        alignItems: 'center !important',
        textAlign: 'center !important',
        marginBottom: '0 !important',
      },
      '& .section-header__title-wrapper, & .section-header__subtitle-wrapper': {
        justifyContent: 'center !important',
        textAlign: 'center !important',
        padding: '0 !important',
      },
      '& .section-header__subtitle-wrapper': {
        marginTop: '8px !important',
      },
      '& .hero-header-title': {
        fontFamily: 'NeueMontreal-Medium !important',
        fontSize: '36px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.72px !important',
        fontWeight: 400,
        color: `${palette.background.benefits} !important`,
        textAlign: 'center !important',
        margin: '0 auto !important',
        maxWidth: '100% !important',
      },
      '& .hero-header-subtitle': {
        fontFamily: 'InterDisplay-Regular !important',
        fontSize: '18px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.54px !important',
        fontWeight: 400,
        color: `${palette.background.benefits} !important`,
        textAlign: 'center !important',
        margin: '0 auto !important',
        maxWidth: '100% !important',
      },
      '& h1,& h2,& h3,& h4,& p': {
        color: `${palette.background.benefits} !important`,
      },
      '& .header-container': {
        justifyContent: 'center !important',
        margin: '0 !important',
        gap: '20px !important',
      },
      '& .hero-link-button, & .hero-link-button.MuiButton-containedPrimary': {
        minHeight: '48px',
        minWidth: '144px',
        padding: '12px 40px !important',
        fontSize: '16px !important',
        fontWeight: 400,
        fontFamily: 'InterDisplay-Regular !important',
        textTransform: 'none !important',
        letterSpacing: '-0.32px',
        lineHeight: '20px !important',
        backgroundColor: `${palette.primary.main} !important`,
        color: `${palette.text.highlight} !important`,
        border: 'none !important',
        boxShadow: 'none !important',
        '&:hover': {
          backgroundColor: `${palette.primary.main} !important`,
          color: `${palette.text.highlight} !important`,
          border: 'none !important',
          opacity: 0.92,
          boxShadow: 'none !important',
        },
      },
      '& .hero-home-button': {
        position: 'relative',
        minHeight: '48px',
        minWidth: '120px',
        padding: '0 20px !important',
        fontSize: '16px !important',
        fontWeight: 400,
        fontFamily: 'InterDisplay-Regular !important',
        textTransform: 'none !important',
        letterSpacing: '-0.32px',
        lineHeight: '20px !important',
        backgroundColor: `${palette.text.highlight} !important`,
        color: `${palette.background.footer} !important`,
        border: 'none !important',
        boxShadow: 'none !important',
        overflow: 'hidden',
        '&::before': {
          display: 'none !important',
          content: 'none',
        },
        '&:hover': {
          backgroundColor: `${palette.text.highlight} !important`,
          color: `${palette.background.footer} !important`,
          border: 'none !important',
          opacity: 0.92,
          boxShadow: 'none !important',
        },
      },
    },

    '& .subscription-wrapper, & .addonsWrapper, & .plan-selection-container': {
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
      },
      '& .MuiSwitch-track': {
        border: 'none',
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-variant-2': {
      marginTop: '0',
    },
    '& .home-hero-wrapper': {
      position: 'relative',
      overflow: 'hidden',
      width: '100%',
      /* Desktop: full-bleed background image with overlaid copy */
      '@media(min-width: 960px)': {
        display: 'flex !important',
        flexDirection: 'column !important',
        justifyContent: 'flex-end',
        width: '100%',
        aspectRatio: '1920 / 780',
        minHeight: '780px',
        height: 'auto !important',
        maxHeight: 'none !important',
        '&::after': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background: `
            linear-gradient(65.48deg, ${palette.overlay.dark60} 23.39%, ${palette.background.benefits}00 57.73%),
            linear-gradient(180deg, ${palette.overlay.dark45} 0%, ${palette.overlay.clear} 42%),
            linear-gradient(186deg, ${palette.overlay.clear} 32%, ${palette.overlay.dark72} 100%)
          `,
          zIndex: 1,
          pointerEvents: 'none',
        },
      },
      '& .hero-background': {
        backgroundColor: palette.background.fill,
        position: 'absolute !important',
        top: 0,
        left: 0,
        width: '100% !important',
        height: '100% !important',
        maxWidth: 'none !important',
        objectFit: 'cover !important',
        objectPosition: 'center center',
        zIndex: 0,
        '@media(max-width: 959px)': {
          /* Figma mobile: slight right bias so family stays framed */
          objectPosition: '54% 12% !important',
        },
      },
      '& .hero-section': {
        flex: '1 1 auto',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        position: 'relative',
        zIndex: 2,
        maxHeight: 'none',
        width: '100% !important',
        maxWidth: 'none !important',
        margin: '0 auto',
        boxShadow: 'none',
        '@media(min-width: 960px)': {
          paddingBottom: '80px',
          minHeight: '0 !important',
          flex: '1 1 auto',
        },
        '& .MuiGrid-container > .MuiGrid-item': {
          '@media(min-width: 960px)': {
            minHeight: '0 !important',
          },
        },
        '& .section-alternate__content > .MuiGrid-container': {
          '@media(max-width: 600px)': {
            justifyContent: 'flex-start !important',
          },
          '@media(min-width: 601px) and (max-width: 959px)': {
            justifyContent: 'center !important',
          },
        },
        '& .section-alternate__content > .MuiGrid-container > .MuiGrid-item': {
          '@media(min-width: 600px)': {
            flexBasis: '100% !important',
            maxWidth: '100% !important',
          },
        },
        '& .section-alternate__content': {
          backgroundColor: 'transparent',
          width: '100% !important',
          maxWidth: '100% !important',
          '@media(max-width: 1200px) and (min-width: 960px)': {
            width: '100% !important',
            padding: '0px 50px !important',
            paddingRight: '0px !important',
          },
          '@media(max-width: 959px)': {
            padding: '0 24px !important',
          },
        },
        '& .section-header': {
          width: '100%',
          '@media(min-width: 960px)': {
            textAlign: 'left',
            justifyContent: 'flex-start',
            maxWidth: 720,
            marginLeft:
              'max(80px, calc((100vw - 1600px) / 2 + 80px)) !important',
            marginRight: 'auto',
            marginTop: 0,
          },
          '@media(max-width: 600px)': {
            textAlign: 'left',
            justifyContent: 'flex-start',
            marginLeft: 0,
            marginRight: 'auto',
            marginTop: 0,
          },
          '@media(min-width: 601px) and (max-width: 959px)': {
            textAlign: 'center !important',
            justifyContent: 'center !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
            marginTop: 0,
            alignItems: 'center !important',
          },
          '& .section-header__overline-wrapper': {
            '@media(max-width: 600px)': {
              justifyContent: 'flex-start !important',
            },
            '@media(min-width: 601px) and (max-width: 959px)': {
              justifyContent: 'center !important',
            },
            color: `${palette.text.highlight} !important`,
          },
          '& .section-header__title-wrapper': {
            '@media(max-width: 600px)': {
              marginLeft: 0,
              marginRight: 'auto',
              justifyContent: 'flex-start !important',
            },
            '@media(min-width: 601px) and (max-width: 959px)': {
              marginLeft: 'auto !important',
              marginRight: 'auto !important',
              justifyContent: 'center !important',
              maxWidth: '100% !important',
              flexBasis: '100% !important',
            },
          },
          '& .section-header__title.home-hero-title': {
            '@media(max-width: 600px)': {
              textAlign: 'left !important',
            },
            '@media(min-width: 601px) and (max-width: 959px)': {
              textAlign: 'center !important',
              marginLeft: 'auto !important',
              marginRight: 'auto !important',
            },
          },
          '& .section-header__subtitle-wrapper': {
            display: 'none !important',
          },
          '& .section-header__cta-wrapper': {
            maxWidth: '100% !important',
            flexBasis: '100% !important',
            marginTop: '32px !important',
            '@media(max-width: 600px)': {
              marginLeft: '0 !important',
              marginRight: 'auto !important',
            },
            '@media(min-width: 601px) and (max-width: 959px)': {
              width: '100% !important',
              marginLeft: 'auto !important',
              marginRight: 'auto !important',
            },
            '@media(min-width: 960px)': {
              maxWidth: '720px !important',
              marginLeft: '0 !important',
              marginRight: 'auto !important',
            },
          },
          '& .section-header__cta-container': {
            flexWrap: 'nowrap',
            '@media(max-width: 600px)': {
              justifyContent: 'flex-start !important',
            },
            '@media(min-width: 601px) and (max-width: 959px)': {
              justifyContent: 'center !important',
            },
          },
          '& .section-header__cta-item-wrapper': {
            gap: '20px !important',
          },
        },
      },
      '& .home-hero-title': {
        fontSize: '80px !important',
        fontFamily: 'NeueMontreal-Medium',
        fontWeight: 400,
        maxWidth: 720,
        marginLeft: 0,
        marginRight: 'auto',
        lineHeight: '80px !important',
        letterSpacing: '-2.4px',
        whiteSpace: 'pre-line',
        color: `${palette.text.heroAccent} !important`,
        '&::first-line': {
          color: `${palette.text.highlight} !important`,
        },
        '@media(max-width: 1280px) and (min-width: 960px)': {
          fontSize: '56px !important',
          lineHeight: '60px !important',
          letterSpacing: '-1.68px !important',
        },
        '@media(max-width: 959px)': {
          fontSize: '40px !important',
          lineHeight: '44px !important',
          letterSpacing: '-1.2px !important',
          color: `${palette.text.highlight} !important`,
          maxWidth: '100% !important',
          '&::first-line': {
            color: `${palette.text.highlight} !important`,
          },
          '@media(max-width: 600px)': {
            textAlign: 'left !important',
            marginLeft: 0,
            marginRight: 'auto',
          },
          '@media(min-width: 601px)': {
            textAlign: 'center !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
          },
        },
      },
      '& .home-hero-subtitle': {
        display: 'none !important',
      },
      '& .hero-link-button, & .login-button': {
        position: 'relative',
        minHeight: '48px',
        padding: '12px 20px !important',
        fontSize: '16px !important',
        fontWeight: 500,
        fontFamily: 'InterDisplay-Regular !important',
        textTransform: 'uppercase !important',
        letterSpacing: '-0.32px',
        lineHeight: '20px !important',
        border: 'none !important',
        borderRadius: '0 !important',
        boxShadow: 'none !important',
        overflow: 'hidden',
        '&::before': {
          display: 'none !important',
          content: 'none',
        },
      },
      '& .hero-link-button, & .hero-link-button.MuiButton-containedPrimary': {
        minWidth: '144px',
        backgroundColor: `${palette.primary.main} !important`,
        color: `${palette.text.highlight} !important`,
        '&:hover': {
          backgroundColor: `${palette.primary.main} !important`,
          color: `${palette.text.highlight} !important`,
          border: 'none !important',
          boxShadow: 'none !important',
          opacity: 0.92,
        },
      },
      '& .login-button, & .login-button.MuiButton-containedSecondary, & .login-button.MuiButton-containedPrimary': {
        minWidth: '123px',
        backgroundColor: `${palette.surface.loginCta} !important`,
        color: `${palette.text.section} !important`,
        '&:hover': {
          backgroundColor: `${palette.surface.loginCta} !important`,
          color: `${palette.text.section} !important`,
          border: 'none !important',
          boxShadow: 'none !important',
          opacity: 0.92,
        },
      },
      /* Mobile + tablet: Figma Hero 4 — photo over heroMobile + bottom fade */
      '@media(max-width: 959px)': {
        display: 'flex !important',
        flexDirection: 'column !important',
        justifyContent: 'flex-end',
        position: 'relative',
        minHeight: '780px',
        height: '780px',
        maxHeight: 'none !important',
        paddingTop: '0 !important',
        backgroundColor: palette.background.heroMobile,
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          left: 0,
          right: 0,
          top: '174px',
          height: '496px',
          backgroundColor: palette.background.heroMobile,
          zIndex: 0,
          pointerEvents: 'none',
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background: `
            linear-gradient(180deg, ${palette.background.heroMobile}00 27%, ${palette.background.heroMobile}CC 100%),
            linear-gradient(185deg, ${palette.background.hero1}00 32%, ${palette.background.heroMobile}CC 100%),
            linear-gradient(191deg, ${palette.background.hero1}00 47%, ${palette.background.heroMobile}CC 100%)
          `,
          zIndex: 1,
          pointerEvents: 'none',
        },
        '& .hero-section': {
          order: 2,
          position: 'relative !important',
          zIndex: 2,
          flex: '1 1 auto !important',
          display: 'flex !important',
          alignItems: 'flex-end !important',
          height: '100% !important',
          minHeight: 'auto !important',
          maxHeight: 'none !important',
          backgroundColor: 'transparent !important',
          paddingBottom: '63px !important',
        },
        '& .hero-section .section-alternate__content > .MuiGrid-container > .MuiGrid-item': {
          maxWidth: '100% !important',
          flexBasis: '100% !important',
        },
        '& .section-alternate__content': {
          padding: '0 24px !important',
          backgroundColor: 'transparent !important',
        },
        '@media(max-width: 600px)': {
          '& .section-header': {
            display: 'flex',
            justifyContent: 'flex-start !important',
            textAlign: 'left !important',
            marginLeft: '0 !important',
            marginRight: 'auto !important',
            maxWidth: '100% !important',
          },
          '& .section-header__overline-wrapper, & .section-header__title-wrapper, & .section-header__subtitle-wrapper':
            {
              justifyContent: 'flex-start !important',
              textAlign: 'left !important',
              marginLeft: '0 !important',
              marginRight: 'auto !important',
            },
          '& .section-header__cta-container': {
            justifyContent: 'flex-start !important',
          },
        },
      },
      /* Tablet: same overlay layout as mobile, centered copy */
      '@media(min-width: 601px) and (max-width: 959px)': {
        minHeight: '780px',
        height: '780px',
        '& .hero-section': {
          alignItems: 'flex-end !important',
          justifyContent: 'center !important',
          paddingBottom: '63px !important',
          '& .section-alternate__content > .MuiGrid-container': {
            justifyContent: 'center !important',
          },
          '& .section-header': {
            textAlign: 'center !important',
            justifyContent: 'center !important',
            alignItems: 'center !important',
          },
          '& .section-header__title-wrapper': {
            justifyContent: 'center !important',
          },
        },
        '& .section-alternate__content': {
          padding: '0 40px !important',
        },
        '& .hero-section .section-header': {
          justifyContent: 'center !important',
          textAlign: 'center !important',
          marginLeft: 'auto !important',
          marginRight: 'auto !important',
          alignItems: 'center !important',
          '& .section-header__overline-wrapper': {
            justifyContent: 'center !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
          },
          '& .section-header__title-wrapper': {
            justifyContent: 'center !important',
            textAlign: 'center !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
            maxWidth: '100% !important',
            flexBasis: '100% !important',
          },
          '& .section-header__title.home-hero-title': {
            textAlign: 'center !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
          },
          '& .section-header__cta-wrapper': {
            maxWidth: '100% !important',
            flexBasis: '100% !important',
            width: '100% !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
          },
          '& .section-header__cta-container': {
            justifyContent: 'center !important',
          },
          '& .section-header__cta-item-wrapper': {
            justifyContent: 'center !important',
          },
        },
        '& .hero-section .home-hero-title': {
          textAlign: 'center !important',
          marginLeft: 'auto !important',
          marginRight: 'auto !important',
        },
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      background: `${palette.background.benefits} !important`,
      backgroundColor: `${palette.background.benefits} !important`,
      width: '100%',
      maxWidth: '100%',
      overflow: 'hidden',
      '& .definition-variant-3': {
        padding: '96px 80px !important',
        maxWidth: '1440px',
        margin: '0 auto',
        width: '100%',
        boxSizing: 'border-box',
        /* Tablet (Figma 18003:61422) */
        '@media(max-width: 1199px) and (min-width: 600px)': {
          padding: '80px 56px !important',
        },
        /* Mobile (Figma 18003:61577) */
        '@media(max-width: 599px)': {
          padding: '56px 24px !important',
        },
      },
      '& .benefits-wrapper': {
        maxWidth: '1280px',
        margin: '0 auto',
        width: '100%',
        boxSizing: 'border-box',
        '& > .MuiGrid-container': {
          alignItems: 'center',
          margin: '0 !important',
          width: '100% !important',
          maxWidth: '100%',
          columnGap: '72px',
          flexWrap: 'wrap !important',
          '@media(max-width: 1199px)': {
            flexDirection: 'column !important',
            flexWrap: 'nowrap !important',
            alignItems: 'stretch !important',
            columnGap: '0 !important',
            rowGap: '72px !important',
          },
          '@media(max-width: 599px)': {
            rowGap: '56px !important',
          },
          '& > .MuiGrid-item': {
            padding: '0 !important',
          },
        },
        '& .customImageWrapper': {
          display: 'flex !important',
          justifyContent: 'center',
          alignItems: 'stretch',
          width: '100% !important',
          maxWidth: '480px !important',
          overflow: 'hidden',
          position: 'relative',
          borderRadius: '24px !important',
          boxSizing: 'border-box',
          backgroundImage: `url('/images/home-images/benefits-hero.webp')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          '@media(min-width: 1200px)': {
            height: '640px !important',
            minHeight: '640px !important',
            flexBasis: '480px !important',
            maxWidth: '480px !important',
          },
          /* Tablet + mobile: full-width image on top */
          '@media(max-width: 1199px)': {
            flex: '0 0 auto !important',
            flexBasis: '100% !important',
            maxWidth: '100% !important',
            width: '100% !important',
            height: '400px !important',
            minHeight: '400px !important',
            margin: '0 !important',
          },
          '& .lazy-load-image-background, & > span': {
            position: 'absolute !important',
            top: '0 !important',
            left: '0 !important',
            right: '0 !important',
            bottom: '0 !important',
            width: '100% !important',
            height: '100% !important',
            minHeight: '100% !important',
            maxWidth: 'none !important',
            display: 'block !important',
            borderRadius: '24px',
            overflow: 'hidden',
            backgroundImage: `url('/images/home-images/benefits-hero.webp') !important`,
            backgroundSize: 'cover !important',
            backgroundPosition: 'center !important',
            backgroundRepeat: 'no-repeat !important',
            '& img, & .image': {
              width: '100% !important',
              height: '100% !important',
              minHeight: '100% !important',
              objectFit: 'cover !important',
              display: 'block !important',
              position: 'absolute',
              top: 0,
              left: 0,
              borderRadius: '24px',
            },
          },
          '& img, & .image': {
            width: '100% !important',
            height: '100% !important',
            minHeight: '100% !important',
            objectFit: 'cover !important',
            display: 'block !important',
            borderRadius: '24px',
          },
        },
        '& .customRightContainer': {
          flex: '1 1 0',
          minWidth: 0,
          display: 'flex',
          flexDirection: 'column',
          gap: '72px',
          boxSizing: 'border-box',
          '@media(max-width: 1199px)': {
            flex: '0 0 auto !important',
            flexBasis: '100% !important',
            maxWidth: '100% !important',
            width: '100% !important',
            gap: '56px',
          },
          '& .definition-header-container': {
            margin: 0,
            width: '100%',
          },
          /* Local MFE: definition-services-container; remote: last grid in right column */
          '& .definition-services-container, & > .MuiGrid-container:last-child': {
            margin: '0 !important',
            width: '100% !important',
            maxWidth: '100%',
            display: 'flex !important',
            flexWrap: 'wrap !important',
            rowGap: '56px',
            columnGap: '64px',
            '@media(max-width: 1199px) and (min-width: 600px)': {
              rowGap: '56px',
              columnGap: '64px',
            },
            '@media(max-width: 599px)': {
              rowGap: '40px',
              columnGap: '0',
              flexDirection: 'column !important',
              flexWrap: 'nowrap !important',
            },
            '& > .MuiGrid-item, & > .service-tile-wrapper': {
              padding: '0 !important',
              boxSizing: 'border-box',
              '@media(min-width: 1200px)': {
                flexBasis: 'calc(50% - 32px) !important',
                maxWidth: 'calc(50% - 32px) !important',
              },
              /* Tablet: keep 2-column cards */
              '@media(max-width: 1199px) and (min-width: 600px)': {
                flexBasis: 'calc(50% - 32px) !important',
                maxWidth: 'calc(50% - 32px) !important',
                width: 'calc(50% - 32px) !important',
              },
              /* Mobile: single column */
              '@media(max-width: 599px)': {
                flexBasis: '100% !important',
                maxWidth: '100% !important',
                width: '100% !important',
              },
            },
          },
        },
      },
      '& .section-header': {
        alignItems: 'flex-start !important',
        marginBottom: '0 !important',
        width: '100%',
      },
      '& .section-header__title-wrapper': {
        justifyContent: 'flex-start !important',
        flexDirection: 'column !important',
        alignItems: 'flex-start !important',
        padding: '0 !important',
      },
      '& .section-header__subtitle-wrapper': {
        display: 'none !important',
      },
      '& .section-header__title': {
        fontWeight: 400,
        whiteSpace: 'pre-line',
        fontFamily: 'NeueMontreal-Medium !important',
        fontSize: '48px !important',
        lineHeight: '56px !important',
        letterSpacing: '-1.44px !important',
        color: `${palette.text.highlight} !important`,
        textAlign: 'left !important',
        paddingBottom: '0 !important',
        '@media(max-width: 1199px)': {
          fontSize: '40px !important',
          lineHeight: '48px !important',
          letterSpacing: '-1.2px !important',
        },
        '@media(max-width: 599px)': {
          fontSize: '40px !important',
          lineHeight: '44px !important',
          letterSpacing: '-1.2px !important',
        },
      },
      '& .definition-service-tile': {
        border: 'none !important',
        borderBottom: `1px solid ${palette.secondary.light} !important`,
        backgroundColor: 'transparent !important',
        padding: '0 0 24px !important',
        margin: '0 !important',
        minHeight: 'unset !important',
        height: '100%',
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        alignItems: 'flex-start !important',
        flexDirection: 'column !important',
        flexWrap: 'nowrap !important',
        gap: '24px !important',
        '& > .MuiGrid-item': {
          padding: '0 !important',
          maxWidth: '100% !important',
          width: '100% !important',
        },
        /* Icon + title row: local MFE class + remote first-child fallback */
        '& > .definition-service-header, & > .MuiGrid-item:first-child': {
          display: 'flex !important',
          alignItems: 'center !important',
          gap: '16px !important',
          margin: '0 !important',
          flexWrap: 'nowrap !important',
          width: '100% !important',
        },
        '& .lazy-load-image-background': {
          width: '56px !important',
          height: '56px !important',
          minWidth: '56px !important',
          maxWidth: '56px !important',
          display: 'inline-block !important',
          flexShrink: '0 !important',
          padding: '0 !important',
          margin: '0 !important',
          borderRadius: '12px',
          overflow: 'hidden',
        },
        '& .image, & img': {
          width: '56px !important',
          height: '56px !important',
          minWidth: '56px !important',
          maxWidth: '56px !important',
          display: 'block !important',
          flexShrink: '0 !important',
          padding: '0 !important',
          margin: '0 !important',
          objectFit: 'contain !important',
        },
      },
      '& .service-tile-wrapper': {
        padding: '0 !important',
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
      },
      '& .definition-service-title': {
        fontWeight: 400,
        fontFamily: 'NeueMontreal-Medium !important',
        fontSize: '24px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.48px !important',
        color: `${palette.text.highlight} !important`,
        textAlign: 'left !important',
        paddingBottom: '0 !important',
        marginBottom: '0 !important',
        flex: '1 1 auto',
        minWidth: 0,
        '@media(max-width: 1199px)': {
          lineHeight: '32px !important',
        },
        '@media(max-width: 599px)': {
          lineHeight: '28px !important',
        },
      },
      '& .definition-service-description': {
        margin: '0 !important',
        fontSize: '16px !important',
        lineHeight: '22px !important',
        color: `${palette.text.highlight} !important`,
        textAlign: 'left !important',
        letterSpacing: '-0.64px !important',
        fontFamily: 'InterDisplay-Regular !important',
        fontWeight: 400,
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        '@media(max-width: 599px)': {
          fontSize: '15px !important',
          letterSpacing: '-0.6px !important',
        },
      },
      '& .section-alternate__content': {
        padding: '0 !important',
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      padding: '0 !important',
      '& .subscription-bg': {
        height: '100%',
        background: palette.surface.pricing,
        backgroundRepeat: 'no-repeat, no-repeat',
      },
      '& .section-alternate': {
        maxWidth: 'none !important',
        width: '100%',
        margin: '0 auto',
      },
      '& .subscription-section': {
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1fr) 480px',
        gridTemplateRows: 'auto auto minmax(0, 1fr)',
        columnGap: '200px',
        rowGap: '40px',
        alignItems: 'stretch',
        margin: '0 auto',
        /* 1280 content + 80px side padding each side */
        maxWidth: '1440px',
        padding: '96px 80px !important',
        width: '100%',
        boxSizing: 'border-box',
        '@media(max-width: 1440px)': {
          columnGap: '120px',
        },
        /* Tablet (Figma 18003:61735): keep 2-column, tighten gap/padding */
        '@media(max-width: 1199px) and (min-width: 600px)': {
          display: 'grid',
          gridTemplateColumns: 'minmax(0, 1fr) minmax(440px, 480px)',
          gridTemplateRows: 'auto auto minmax(0, 1fr)',
          columnGap: '40px',
          rowGap: '40px',
          padding: '80px 56px !important',
          maxWidth: '100%',
        },
        /* Mobile (Figma 18003:61864): stack, summary above card */
        '@media(max-width: 599px)': {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          rowGap: '0',
          gap: '0',
          padding: '56px 24px !important',
        },
      },
      '& .select-plan-button, & .subscription-get-started-button': {
        width: 'auto !important',
        minWidth: 'unset !important',
        maxWidth: 'fit-content',
        backgroundColor: `${palette.primary.main} !important`,
        color: `${palette.text.highlight} !important`,
        border: 'none !important',
        boxShadow: 'none !important',
        padding: '12px 32px !important',
        fontSize: '16px !important',
        lineHeight: '20px !important',
        letterSpacing: '-0.32px !important',
        fontWeight: 400,
        fontFamily: 'InterDisplay-Regular !important',
        textTransform: 'none !important',
        '&:hover': {
          backgroundColor: `${palette.primary.main} !important`,
          color: `${palette.text.highlight} !important`,
          opacity: 0.92,
        },
      },
      /* Local MFE semantic hook + remote MFE :has() fallback */
      '& .subscription-cta-wrapper, & .subscription-section > .MuiBox-root:has(> .select-plan-button), & .subscription-section > .MuiBox-root:has(> .subscription-get-started-button)': {
        gridColumn: 1,
        gridRow: 2,
        justifySelf: 'start',
        alignSelf: 'start',
        order: 2,
        margin: '0 !important',
        textAlign: 'left !important',
        width: 'auto !important',
        /* Tablet: still left-aligned under title */
        '@media(max-width: 1199px) and (min-width: 600px)': {
          justifySelf: 'start',
          textAlign: 'left !important',
          margin: '0 !important',
        },
        /* Mobile: centered after title/subtitle */
        '@media(max-width: 599px)': {
          order: 2,
          alignSelf: 'center',
          margin: '32px auto 0 !important',
          textAlign: 'center !important',
        },
      },
      '& .summary-subtext': {
        display: 'none !important',
      },
      '& .summary-text': {
        gridColumn: 1,
        gridRow: 3,
        alignSelf: 'end',
        order: 3,
        borderTop: `1px solid ${palette.background.border}`,
        fontWeight: 400,
        fontSize: '20px !important',
        lineHeight: '26px !important',
        letterSpacing: '-0.8px !important',
        fontFamily: 'InterDisplay-Regular !important',
        color: `${palette.text.content} !important`,
        margin: '0 !important',
        paddingTop: '32px !important',
        textAlign: 'left !important',
        width: '100%',
        maxWidth: '100%',
        /* Tablet: left-aligned, 18/28 */
        '@media(max-width: 1199px) and (min-width: 600px)': {
          fontSize: '18px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.72px !important',
          textAlign: 'left !important',
          paddingTop: '32px !important',
          alignSelf: 'end',
          order: 3,
        },
        /* Mobile: centered above card */
        '@media(max-width: 599px)': {
          order: 3,
          alignSelf: 'stretch',
          textAlign: 'center !important',
          fontSize: '16px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.64px !important',
          paddingTop: '24px !important',
          marginTop: '40px !important',
        },
      },
      '& .subscription-tabs-box, & .subscription-section > .MuiBox-root:has(.subscription-carousel-wrapper), & .subscription-section > .MuiBox-root:has(.carousel-container), & .subscription-section > .MuiBox-root:has(.react-multi-carousel-list)': {
        gridColumn: 2,
        gridRow: '1 / -1',
        alignSelf: 'center',
        justifySelf: 'end',
        width: '100%',
        maxWidth: '480px',
        margin: '0 !important',
        order: 4,
        /* Tablet: card stays on right, can flex down to 440 */
        '@media(max-width: 1199px) and (min-width: 600px)': {
          maxWidth: '480px',
          minWidth: '0',
          justifySelf: 'stretch',
          alignSelf: 'center',
          order: 4,
        },
        /* Mobile: full-width card last */
        '@media(max-width: 599px)': {
          order: 4,
          maxWidth: '100%',
          width: '100%',
          marginTop: '56px !important',
        },
      },
      '& .section-header': {
        gridColumn: 1,
        gridRow: 1,
        alignSelf: 'start',
        margin: '0 !important',
        maxWidth: '100% !important',
        width: '100%',
        order: 1,
        transform: 'none !important',
        '& .section-header__title-wrapper': {
          display: 'flex',
          justifyContent: 'flex-start !important',
          padding: '0 !important',
          '@media(max-width: 599px)': {
            justifyContent: 'center !important',
          },
        },
        '& .section-header__subtitle-wrapper': {
          display: 'flex',
          justifyContent: 'flex-start !important',
          padding: '20px 0 0 !important',
          '@media(max-width: 599px)': {
            justifyContent: 'center !important',
          },
        },
      },
      '& .section-header__title, & .summary-text, & .summary-subtext, & .subscription-tabs-label': {
        color: `${palette.text.content} !important`,
      },
      '& .section-header__title': {
        fontWeight: 400,
        fontFamily: 'NeueMontreal-Medium !important',
        fontSize: '56px !important',
        lineHeight: '64px !important',
        letterSpacing: '-1.68px !important',
        textAlign: 'left !important',
        whiteSpace: 'pre-line',
        maxWidth: '100%',
        padding: '0 !important',
        color: `${palette.text.content} !important`,
        /* Tablet (Figma): 48 / 64, -1.44 */
        '@media(max-width: 1199px) and (min-width: 600px)': {
          fontSize: '48px !important',
          lineHeight: '64px !important',
          letterSpacing: '-1.44px !important',
          textAlign: 'left !important',
        },
        /* Mobile (Figma): 36 / 44, -1.08, centered */
        '@media(max-width: 599px)': {
          fontSize: '36px !important',
          lineHeight: '44px !important',
          letterSpacing: '-1.08px !important',
          textAlign: 'center !important',
        },
      },
      '& .section-header__subtitle': {
        fontWeight: 400,
        fontFamily: 'InterDisplay-Regular !important',
        fontSize: '20px !important',
        lineHeight: '26px !important',
        letterSpacing: '-0.8px !important',
        textAlign: 'left !important',
        color: `${palette.text.content} !important`,
        maxWidth: '100%',
        /* Tablet: 18 / 28, -0.72 */
        '@media(max-width: 1199px) and (min-width: 600px)': {
          fontSize: '18px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.72px !important',
          textAlign: 'left !important',
        },
        /* Mobile: 16 / 22, -0.64, centered */
        '@media(max-width: 599px)': {
          fontSize: '16px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.64px !important',
          textAlign: 'center !important',
        },
      },
      '& #pricing-benefit-section': {
        '& .subscription-carousel-wrapper': {
          width: '100%',
        },
        '& .carousel-container, & .react-multi-carousel-list': {
          maxWidth: '100% !important',
          width: '100%',
          margin: '0 !important',
        },
        '& .react-multi-carousel-track': {
          justifyContent: 'flex-end',
          '@media(max-width: 1199px) and (min-width: 600px)': {
            justifyContent: 'stretch',
          },
          '@media(max-width: 599px)': {
            justifyContent: 'center',
          },
        },
        '& .react-multi-carousel-item': {
          width: '480px !important',
          maxWidth: '480px !important',
          flex: '0 0 480px !important',
          '@media(max-width: 1199px) and (min-width: 600px)': {
            width: '100% !important',
            maxWidth: '100% !important',
            flex: '1 1 100% !important',
          },
          '@media(max-width: 599px)': {
            width: '100% !important',
            maxWidth: '100% !important',
            flex: '1 1 100% !important',
          },
        },
        '& .react-multi-carousel-item:not(.react-multi-carousel-item--active)': {
          display: 'none !important',
        },
        '& .react-multiple-carousel__arrow': {
          display: 'none !important',
        },
        '& .subscription-carousel-wrapper .react-multi-carousel-dot-list, & .carousel-container .react-multi-carousel-dot-list': {
          display: 'none !important',
        },
        '& .carousel-single-item.MuiGrid-container, & .subscription-plan-card-item': {
          width: '100%',
          maxWidth: '100%',
          margin: 0,
          justifyContent: 'flex-end !important',
          '@media(max-width: 1199px) and (min-width: 600px)': {
            justifyContent: 'stretch !important',
          },
          '@media(max-width: 599px)': {
            justifyContent: 'center !important',
          },
        },
        '& .planCard': {
          width: '100% !important',
          maxWidth: '480px !important',
          margin: '0 0 0 auto',
          fontWeight: 400,
          fontSize: '14px !important',
          lineHeight: '18px !important',
          letterSpacing: '-0.28px !important',
          borderRadius: '12px !important',
          border: `1px solid ${palette.background.border} !important`,
          boxShadow: 'none !important',
          background: `${palette.text.highlight} !important`,
          color: `${palette.text.content} !important`,
          overflow: 'hidden',
          '@media(max-width: 1199px) and (min-width: 600px)': {
            margin: '0',
            maxWidth: '100% !important',
            minWidth: '0',
          },
          '@media(max-width: 599px)': {
            margin: '0 auto',
            maxWidth: '100% !important',
          },
          '&:hover': {
            color: palette.text.content,
            background: `${palette.text.highlight} !important`,
            border: `1px solid ${palette.background.border} !important`,
            boxShadow: 'none !important',
          },
          '& .MuiCardContent-root, & .customCardContent': {
            padding: '32px 24px !important',
            '&:last-child': {
              padding: '32px 24px !important',
            },
          },
          '& .description-cta': {
            marginBottom: '24px !important',
            width: '100%',
          },
          '& .description-cta__button-group, & .description-cta__primary-button-wrapper, & .customButtonWrapper, & .cardDivider, & .buttonWrapper, & .MuiDivider-root, & hr, & .dependentPriceInfo, & .customUpfrontWrapper, & .upfrontWrapper': {
            display: 'none !important',
          },
          '& .MuiButton-containedPrimary, & .MuiButton-outlinedPrimary, & .MuiButton-contained, & .MuiButton-outlined': {
            display: 'none !important',
          },
          '& .planCardHeaderContainer, & .titleContainer, & .description-cta__title': {
            justifyContent: 'flex-start !important',
            margin: '0 !important',
          },
          '& .customcardTitle, & .cardTitle, & .description-cta__title, & .description-cta__title .MuiTypography-root': {
            fontWeight: 400,
            fontFamily: 'NeueMontreal-Medium !important',
            fontSize: '24px !important',
            lineHeight: '28px !important',
            letterSpacing: '-0.48px !important',
            color: `${palette.text.content} !important`,
            textAlign: 'left !important',
          },
          '& .planCardDescription > .MuiGrid-container': {
            margin: '0 !important',
            width: '100%',
          },
          '& .planCardDescription > .MuiGrid-container > .MuiGrid-item': {
            padding: '0 !important',
            width: '100%',
            maxWidth: '100%',
          },
          /* Hide empty price row when API doesn’t return a primary price */
          '& .planCardDescription > .MuiGrid-container > .MuiGrid-item:has(> .MuiGrid-container:empty)': {
            display: 'none !important',
          },
          '& .customBenefitsContainer, & .benefitsContainer': {
            margin: '0 !important',
            padding: '0 !important',
            '& > .MuiGrid-container': {
              margin: '0 !important',
              width: '100%',
            },
            '& > .MuiGrid-container > .MuiGrid-item': {
              padding: '0 !important',
            },
            '& .bold': {
              fontWeight: 400,
              margin: '0 0 20px !important',
              fontSize: '20px !important',
              lineHeight: '24px !important',
              letterSpacing: '-0.4px !important',
              color: `${palette.text.tertiaryLight} !important`,
              fontFamily: 'NeueMontreal-Medium !important',
            },
            '& .cptCodes': {
              fontSize: '14px !important',
              lineHeight: '18px !important',
              letterSpacing: '-0.28px !important',
              color: `${palette.text.content} !important`,
              fontFamily: 'InterDisplay-Regular !important',
            },
            '& .MuiAvatar-root': {
              width: '20px !important',
              height: '20px !important',
              margin: '0 !important',
            },
            '& .benefit-item': {
              margin: '0 0 12px !important',
              width: '100%',
            },
            '& .benefit-item:last-child': {
              marginBottom: '0 !important',
            },
          },
          '& .primaryPriceInfo, & .price-item': {
            backgroundColor: `${palette.surface.grey} !important`,
            borderRadius: '8px !important',
            padding: '20px 24px !important',
            margin: '0 0 24px !important',
            textAlign: 'center !important',
            maxWidth: '100% !important',
            flexBasis: '100% !important',
            display: 'flex !important',
            justifyContent: 'center !important',
          },
          '& .price-value': {
            fontWeight: 400,
            fontSize: '36px !important',
            fontFamily: 'NeueMontreal-Medium !important',
            lineHeight: '40px !important',
            letterSpacing: '-0.72px !important',
            color: `${palette.text.content} !important`,
            '@media(max-width: 599px)': {
              fontSize: '32px !important',
              lineHeight: '36px !important',
              letterSpacing: '-0.64px !important',
            },
          },
          '& .price-frequency, & .display-frequency': {
            fontSize: '14px !important',
            lineHeight: '18px !important',
            letterSpacing: '-0.28px !important',
            color: `${palette.text.tertiaryLight} !important`,
          },
          '& .customSubscriberName': {
            fontSize: '14px !important',
            lineHeight: '18px !important',
            letterSpacing: '-0.28px !important',
            color: `${palette.text.tertiaryLight} !important`,
          },
        },
        '& .plans-loader': {
          color: palette.text.content,
        },
        '& .bold': {
          fontWeight: 400,
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
          color: `${palette.text.tertiaryLight} !important`,
          fontFamily: 'NeueMontreal-Medium !important',
        },
        '& .savings-summary-link': {
          color: `${palette.text.content} !important`,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      backgroundColor: `${palette.surface.pricing} !important`,
      borderTop: 'none !important',
      '& .section': {
        padding: '96px 80px !important',
        '@media(min-width: 600px) and (max-width: 1024px)': {
          padding: '64px 40px !important',
        },
        '@media(max-width: 600px)': {
          padding: '48px 20px !important',
        },
      },
      '& .howitworks-wrapper': {
        maxWidth: '1280px',
        margin: '0 auto',
        padding: '0 !important',
        width: '100%',
      },
      '& .howitworks-grid': {
        display: 'grid !important',
        gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 600px)',
        gap: '120px !important',
        margin: '0 !important',
        alignItems: 'center',
        width: '100%',
        '@media(max-width: 1200px)': {
          gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
          gap: '56px !important',
        },
        '@media(max-width: 900px)': {
          gridTemplateColumns: '1fr',
          gap: '40px !important',
        },
        '& > .MuiGrid-item': {
          padding: '0 !important',
          maxWidth: 'none !important',
          flexBasis: 'auto !important',
          width: 'auto !important',
        },
        '& > .cover-image-wrapper.MuiGrid-item': {
          width: '100% !important',
          minWidth: '0 !important',
        },
      },
      '& .howitworks-wrapper-left': {
        padding: '0 !important',
        '& > .MuiGrid-container': {
          margin: '0 !important',
          width: '100%',
          '& > .MuiGrid-item': {
            padding: '0 !important',
            maxWidth: '100% !important',
            flexBasis: '100% !important',
            width: '100% !important',
          },
        },
      },
      '& .howitworks-title': {
        marginBottom: '64px !important',
        '& .section-header': {
          alignItems: 'flex-start !important',
          marginBottom: '0 !important',
        },
        '& .section-header__title-wrapper': {
          justifyContent: 'flex-start !important',
          padding: '0 !important',
          marginBottom: '0 !important',
        },
        '& .section-header__subtitle-wrapper': {
          justifyContent: 'flex-start !important',
          padding: '0 !important',
          marginTop: '12px !important',
        },
        '& .section-header__title': {
          whiteSpace: 'pre-line',
          fontFamily: 'NeueMontreal-Medium !important',
          fontSize: '48px !important',
          lineHeight: '56px !important',
          letterSpacing: '-1.44px !important',
          fontWeight: 400,
          color: `${palette.text.section} !important`,
          textAlign: 'left !important',
          paddingBottom: '0 !important',
          '@media(min-width: 600px) and (max-width: 1200px)': {
            fontSize: '44px !important',
            lineHeight: '48px !important',
            letterSpacing: '-0.88px !important',
          },
          '@media(max-width: 600px)': {
            fontSize: '40px !important',
            lineHeight: '44px !important',
            letterSpacing: '-0.8px !important',
          },
        },
        '& .section-header__subtitle': {
          fontWeight: 400,
          fontFamily: 'InterDisplay-Regular !important',
          fontSize: '20px !important',
          lineHeight: '26px !important',
          letterSpacing: '-0.8px !important',
          color: `${palette.text.tertiaryLight} !important`,
          textAlign: 'left !important',
          '@media(max-width: 1200px)': {
            fontSize: '18px !important',
            lineHeight: '24px !important',
          },
        },
      },
      '& .cover-image-wrapper': {
        display: 'flex !important',
        justifyContent: 'center',
        alignItems: 'stretch',
        width: '100% !important',
        overflow: 'hidden',
        position: 'relative',
        borderRadius: '24px !important',
        '@media(min-width: 600px) and (max-width: 1024px)': {
          height: '480px !important',
          minHeight: '480px !important',
        },
        '@media(min-width: 1024px)': {
          height: '560px !important',
          minHeight: '560px !important',
          maxWidth: '600px !important',
          width: '600px !important',
          marginLeft: 'auto',
        },
        '@media(max-width: 600px)': {
          height: '382px !important',
          minHeight: '382px !important',
        },
        '& .lazy-load-image-background': {
          width: '100% !important',
          height: '100% !important',
          minHeight: '100% !important',
          display: 'block !important',
          position: 'relative',
          borderRadius: '24px',
          overflow: 'hidden',
          backgroundImage: `url('/images/home-images/how-it-works.webp')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        },
        '& img, & .image, & .how-cover-image': {
          width: '100% !important',
          height: '100% !important',
          minHeight: '100% !important',
          objectFit: 'cover !important',
          display: 'block !important',
          position: 'absolute',
          top: 0,
          left: 0,
          borderRadius: '24px',
        },
      },
      '& .step-counter-item': {
        paddingTop: '0 !important',
        paddingBottom: '0 !important',
      },
      '& .step-counter': {
        borderRadius: '50%',
        backgroundColor: `${palette.surface.pricing} !important`,
        border: `1.5px solid ${palette.text.stepBorder} !important`,
        color: `${palette.text.nav} !important`,
        fontSize: '16px !important',
        fontWeight: 500,
        fontFamily: 'InterDisplay-Regular !important',
        letterSpacing: '-0.32px !important',
        lineHeight: '20px !important',
        width: '40px !important',
        height: '40px !important',
        minWidth: '40px !important',
        display: 'inline-flex !important',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        boxSizing: 'border-box',
      },
      '& .working-steps-main-container': {
        width: '100%',
        display: 'flex !important',
        flexDirection: 'column !important',
        gap: '0 !important',
      },
      '& .working-steps-container': {
        maxWidth: 'none',
        width: '100%',
        margin: '0 !important',
        gap: '24px',
        paddingBottom: '0 !important',
        borderBottom: 'none !important',
        alignItems: 'flex-start !important',
        flexWrap: 'nowrap !important',
        '& > .MuiGrid-item': {
          padding: '0 !important',
        },
        '& .step-title': {
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
          fontWeight: 400,
          fontFamily: 'NeueMontreal-Medium !important',
          color: `${palette.text.section} !important`,
          paddingBottom: '10px !important',
          marginBottom: '0 !important',
        },
        '& .step-content': {
          fontSize: '16px !important',
          color: `${palette.text.tertiaryLight} !important`,
          lineHeight: '22px !important',
          letterSpacing: '-0.64px !important',
          fontWeight: 400,
          fontFamily: 'InterDisplay-Regular !important',
        },
      },
      '& .working-steps-container:not(:last-child)': {
        marginBottom: '32px !important',
        paddingBottom: '32px !important',
        position: 'relative',
        '&::after': {
          content: '""',
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: '0',
          height: '1px',
          backgroundColor: palette.background.border,
          pointerEvents: 'none',
        },
      },
      '& .step-started-button': {
        display: 'none !important',
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .select-location-grid': {
        width: '100%',
        maxWidth: 'unset',
        flexBasis: 'auto',
      },
      '& .service-procedure-table': {
        border: `1px solid ${palette.secondary.main} !important`,
        '& .savings-topheader': {
          color: `${palette.text.primary} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .savings-contact-card': {
        padding: '0px 0px 0px 0px !important',
        backgroundColor: `${palette.primary.light} !important`,
      },

      '& .footer-bar': {
        backgroundColor: `${palette.background.benefits} !important`,
      },
      '& .footer-bar-text': {
        color: `${palette.text.highlight} !important`,
      },
      '& .MuiButton-containedSecondary, & .view-more-button': {
        backgroundColor: `${palette.primary.main} !important`,
        color: `${palette.text.highlight} !important`,
        border: 'none !important',
        fontSize: '16px !important',
        lineHeight: '20px !important',
        letterSpacing: '-0.32px !important',
        fontWeight: 400,
        fontFamily: 'InterDisplay-Regular !important',
        textTransform: 'none !important',
        '&:hover': {
          backgroundColor: `${palette.primary.main} !important`,
          color: `${palette.text.highlight} !important`,
          opacity: 0.92,
        },
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      position: 'relative',
      background: `${palette.surface.learnMore} !important`,
      borderTop: 'none !important',
      padding: '80px !important',
      '@media(max-width: 1024px)': {
        padding: '64px 40px !important',
      },
      '@media(max-width: 600px)': {
        padding: '48px 20px !important',
      },
      '& .hero-static-bg': {
        display: 'none !important',
      },
      '& .section-alternate.hero-static-section': {
        maxWidth: '1280px !important',
        width: '100%',
        margin: '0 auto !important',
        overflow: 'visible !important',
        padding: '0 !important',
      },
      '& .section-alternate': {
        '& .section-alternate__content': {
          background: 'transparent !important',
          border: 'none !important',
          borderRadius: '0 !important',
          padding: '0 !important',
          width: '100%',
          boxSizing: 'border-box',
        },
      },
      '& .section-header': {
        alignItems: 'flex-start !important',
        marginBottom: '0 !important',
      },
      '& .section-header__title-wrapper': {
        justifyContent: 'flex-start !important',
        padding: '0 !important',
        marginBottom: '0 !important',
      },
      '& .section-header__subtitle-wrapper': {
        justifyContent: 'flex-start !important',
        padding: '0 !important',
        marginTop: '12px !important',
      },
      '& .section-header__title': {
        color: `${palette.text.section} !important`,
        fontWeight: 400,
        fontFamily: 'NeueMontreal-Medium !important',
        fontSize: '44px !important',
        lineHeight: '44px !important',
        letterSpacing: '-0.88px !important',
        textAlign: 'left !important',
        paddingBottom: '0 !important',
        '@media screen and (max-width: 700px)': {
          fontSize: '32px !important',
          lineHeight: '36px !important',
          letterSpacing: '-0.64px !important',
        },
      },
      '& .section-header__subtitle': {
        color: `${palette.text.section} !important`,
        opacity: 0.8,
        fontWeight: 400,
        fontFamily: 'InterDisplay-Regular !important',
        fontSize: '18px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.54px !important',
        textAlign: 'left !important',
      },
      '& .hero-static-section-grid': {
        margin: '0 !important',
        width: '100%',
        alignItems: 'center !important',
        justifyContent: 'space-between !important',
        flexWrap: 'nowrap !important',
        '& > .MuiGrid-item': {
          padding: '0 !important',
        },
        '@media(max-width: 900px)': {
          flexWrap: 'wrap !important',
          rowGap: '24px',
        },
      },
      '& .hero-button-wrapper': {
        '& .primary-static-button, & .MuiButton-root': {
          backgroundColor: `${palette.primary.main} !important`,
          color: `${palette.text.highlight} !important`,
          border: 'none !important',
          fontSize: '18px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.36px !important',
          fontWeight: 500,
          fontFamily: 'InterDisplay-Regular !important',
          textTransform: 'uppercase !important',
          padding: '16px 24px !important',
          minWidth: 'unset !important',
          boxShadow: 'none !important',
          whiteSpace: 'nowrap',
          borderRadius: '0 !important',
          '&:hover': {
            backgroundColor: `${palette.primary.main} !important`,
            color: `${palette.text.highlight} !important`,
            border: 'none !important',
            opacity: 0.92,
            boxShadow: 'none !important',
          },
        },
        '@media(min-width: 900px)': {
          display: 'flex !important',
          justifyContent: 'flex-end !important',
          alignItems: 'center !important',
        },
        '@media(max-width: 900px)': {
          display: 'flex !important',
          justifyContent: 'flex-start !important',
          marginTop: '0 !important',
        },
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .hero-header-title': {
        fontFamily: 'NeueMontreal-Medium !important',
        fontSize: '48px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.96px !important',
        fontWeight: 400,
      },
      '& .hero-header-subtitle': {
        fontFamily: 'InterDisplay-Regular !important',
        fontSize: '18px !important',
        lineHeight: '22px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 400,
      },
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        background: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.primary.main} !important`,
      },
      /* Find provider cards: stable MFE hook + remote data-testid fallback */
      '& .card-wrapper .select-office-button, & .card-wrapper [data-testid^="select-office-button"]': {
        color: `${palette.text.highlight} !important`,
        border: 'none !important',
        textTransform: 'none !important',
        boxShadow: 'none !important',
        '&:hover': {
          backgroundColor: `${palette.primary.main} !important`,
          color: `${palette.text.highlight} !important`,
          border: 'none !important',
        },
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.text.primary}`,
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
        },
      },
    },

    /* FAQ */
    '& .faq-wrapper': {
      background: `${palette.background.main} !important`,
    },
    '& .faq-hero-section': {
      '& .hero-header-title, & .hero-header-subtitle': {
        margin: '0 auto !important',
        maxWidth: '100% !important',
      },
      '& .header-container': {
        margin: '0 !important',
      },
      '@media screen and (max-width: 900px)': {
        '& .faq-hero-internal': {
          marginTop: '0 !important',
          padding: '64px 24px !important',
        },
      },
    },
    '& .faqInnerContainer': {
      background: `${palette.background.main} !important`,
      padding: '96px 80px !important',
      maxWidth: '1440px',
      margin: '0 auto',
      width: '100%',
      boxSizing: 'border-box',
      '@media(max-width: 1024px)': {
        padding: '64px 40px !important',
      },
      '@media(max-width: 600px)': {
        padding: '48px 20px !important',
      },
      '& .faq-header-container, & .faqContainer': {
        display: 'none !important',
      },
      '& .faq-questions-grid': {
        display: 'flex !important',
        flexWrap: 'nowrap !important',
        gap: '56px !important',
        margin: '0 !important',
        width: '100% !important',
        maxWidth: '1280px',
        marginLeft: 'auto !important',
        marginRight: 'auto !important',
        justifyContent: 'flex-start !important',
        alignItems: 'flex-start !important',
        '@media(max-width: 959px)': {
          flexWrap: 'wrap !important',
          gap: '40px !important',
        },
      },
      '& .faq-questions-tabs, & .faq-questions-panels': {
        padding: '0 !important',
        margin: '0 !important',
      },
      '& .faq-questions-tabs': {
        flex: '0 0 296px !important',
        maxWidth: '296px !important',
        width: '296px !important',
        '@media(max-width: 959px)': {
          flex: '1 1 100% !important',
          maxWidth: '100% !important',
          width: '100% !important',
        },
      },
      '& .faq-questions-panels': {
        flex: '1 1 0 !important',
        maxWidth: 'none !important',
        minWidth: 0,
        width: 'auto !important',
        '@media(max-width: 959px)': {
          flex: '1 1 100% !important',
          maxWidth: '100% !important',
        },
      },
      '& .MuiTabs-root': {
        width: '296px !important',
        maxWidth: '296px !important',
        '@media(max-width: 959px)': {
          width: '100% !important',
          maxWidth: '100% !important',
        },
      },
      '& .MuiTabs-root .MuiTabs-flexContainer': {
        gap: '8px',
        alignItems: 'stretch',
      },
      '& .MuiTab-root, & .faq-link': {
        maxWidth: '296px !important',
        minWidth: '296px !important',
        minHeight: '56px !important',
        maxHeight: '56px !important',
        padding: '20px 32px 20px 24px !important',
        textTransform: 'none !important',
        fontFamily: 'NeueMontreal-Medium !important',
        fontSize: '18px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.72px !important',
        fontWeight: 500,
        color: `${palette.text.tertiaryLight} !important`,
        alignItems: 'flex-start !important',
        opacity: 1,
        borderRadius: 0,
        borderLeft: '2px solid transparent !important',
        textAlign: 'left !important',
        justifyContent: 'flex-start !important',
        '@media(max-width: 959px)': {
          minWidth: 'auto !important',
          maxWidth: 'none !important',
        },
      },
      '& .faq-link': {
        display: 'flex !important',
        width: '100% !important',
        '&:hover': {
          background: 'transparent !important',
        },
      },
      '& .MuiTab-root.Mui-selected, & .faq-link.Mui-selected, & .faq-link[aria-selected="true"]': {
        backgroundColor: `${palette.primary.light} !important`,
        color: `${palette.text.content} !important`,
        borderLeft: `2px solid ${palette.surface.tabAccent} !important`,
      },
      '& .MuiTabs-indicator': {
        display: 'none !important',
      },
      '& .accordion': {
        display: 'flex',
        flexDirection: 'column',
        gap: '32px',
        width: '100%',
      },
      '& .accordion__item-wrapper': {
        boxShadow: 'none !important',
        margin: '0 !important',
        overflow: 'hidden !important',
        backgroundColor: `${palette.background.main} !important`,
        border: `1px solid ${palette.background.border} !important`,
        borderRadius: '8px !important',
        '&::before': {
          display: 'none !important',
        },
        '&.Mui-expanded': {
          backgroundColor: `${palette.background.main} !important`,
          border: `1px solid ${palette.background.border} !important`,
          borderRadius: '8px !important',
          margin: '0 !important',
        },
      },
      '& .accordion__item-wrapper .MuiAccordionSummary-root': {
        minHeight: 'unset !important',
        padding: '16px !important',
        margin: 0,
      },
      '& .accordion__item-wrapper.Mui-expanded .MuiAccordionSummary-root': {
        minHeight: 'unset !important',
        backgroundColor: 'transparent !important',
        border: 'none !important',
        borderRadius: '0 !important',
        padding: '16px 16px 0 !important',
      },
      '& .accordion__item-wrapper .MuiAccordionSummary-content': {
        margin: '0 !important',
      },
      '& .accordion__item-wrapper .MuiAccordionSummary-content.Mui-expanded': {
        margin: '0 !important',
      },
      '& .accordion__item-wrapper .MuiAccordionDetails-root': {
        padding: '16px 64px 16px 16px !important',
        backgroundColor: 'transparent !important',
      },
      '& .MuiAccordionSummary-expandIcon': {
        transform: 'none !important',
        padding: '2px',
        marginRight: 0,
      },
      '& .expandIcon, & .collapseIcon': {
        width: '20px !important',
        height: '20px !important',
        color: 'transparent !important',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'contain',
        border: 'none !important',
        borderRadius: 0,
        padding: '0 !important',
        fontSize: 0,
      },
      '& .expandIcon': {
        backgroundImage: `url('/images/faq/faq-plus-icon.svg')`,
      },
      '& .collapseIcon': {
        backgroundImage: `url('/images/faq/faq-minus-icon.svg')`,
      },
      '& .accorion__item-title-container': {
        '& .MuiTypography-subtitle1, & .accorion_item-title, & .MuiTypography-h6':
          {
            fontFamily: 'NeueMontreal-Medium !important',
            fontSize: '18px !important',
            lineHeight: '24px !important',
            letterSpacing: '-0.72px !important',
            fontWeight: 500,
            color: `${palette.text.content} !important`,
          },
      },
      '& .accordion__collapsable-text-container': {
        margin: 0,
        width: '100%',
      },
      '& .accordion__collapsable-text-wrapper': {
        padding: '0 !important',
      },
      '& .accordion__collapsable-text': {
        color: `${palette.text.tertiaryLight} !important`,
        fontFamily: 'InterDisplay-Regular !important',
        fontSize: '14px !important',
        lineHeight: '18px !important',
        letterSpacing: '-0.28px !important',
        fontWeight: 400,
      },
    },
    '& .faq-contact-section': {
      background: `${palette.primary.light} !important`,
      borderTop: 'none !important',
      width: '100%',
      margin: 'unset',
      maxWidth: 'unset',
      padding: '96px 80px !important',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '64px',
      '@media(max-width: 1024px) and (min-width: 900px)': {
        padding: '64px 40px !important',
        gap: '48px',
      },
      '@media(max-width: 900px) and (min-width: 600px)': {
        padding: '64px 40px !important',
        gap: '40px',
      },
      '@media(max-width: 600px) ': {
        padding: '48px 20px !important',
        gap: '32px',
      },
      '& > .MuiGrid-item': {
        width: '100%',
        maxWidth: '1280px',
      },
      '& .section-header': {
        marginBottom: '0 !important',
        alignItems: 'center !important',
      },
      '& .section-header__title-wrapper, & .section-header__subtitle-wrapper': {
        justifyContent: 'center !important',
        padding: '0 !important',
      },
      '& .section-header__subtitle-wrapper': {
        marginTop: '8px !important',
      },
      '& .contact-provider-title': {
        display: 'none',
      },
      '& .contact-img-wrapper': {
        width: '56px !important',
        maxWidth: '56px !important',
        minWidth: '56px !important',
        minHeight: '56px !important',
        display: 'flex !important',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 !important',
        boxSizing: 'border-box',
        backgroundColor: 'transparent !important',
        border: 'none !important',
        borderRadius: '0 !important',
        flexShrink: 0,
        '& img, & .image': {
          width: '56px !important',
          height: '56px !important',
          maxWidth: '56px !important',
          display: 'block',
        },
      },
      '& .contact-card-title': {
        fontFamily: 'NeueMontreal-Medium !important',
        fontSize: '36px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.72px !important',
        fontWeight: 400,
        color: `${palette.text.content} !important`,
        textAlign: 'center !important',
        '@media(max-width: 600px)': {
          fontSize: '32px !important',
          lineHeight: '36px !important',
          letterSpacing: '-0.64px !important',
        },
      },
      '& .contact-card-subtitle': {
        color: `${palette.text.tertiaryLight} !important`,
        fontSize: '20px !important',
        lineHeight: '26px !important',
        letterSpacing: '-0.8px !important',
        fontWeight: 400,
        fontFamily: 'InterDisplay-Regular !important',
        maxWidth: 'unset !important',
        textAlign: 'center !important',
        '@media(max-width: 600px)': {
          fontSize: '18px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
        },
      },
      '& .provider-contact-details': {
        fontSize: '16px !important',
        fontFamily: 'NeueMontreal-Medium !important',
        lineHeight: '18px !important',
        letterSpacing: '-0.32px !important',
        fontWeight: 400,
        color: `${palette.text.tertiaryLight} !important`,
      },
      '& .provider-contact-link': {
        color: `${palette.text.content} !important`,
        fontSize: '20px !important',
        lineHeight: '26px !important',
        letterSpacing: '-0.4px !important',
        fontFamily: 'InterDisplay-Regular !important',
        fontWeight: 400,
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'normal',
        maxWidth: '100%',
        paddingTop: '8px',
        textDecoration: 'none !important',
        '@media(max-width: 600px)': {
          fontSize: '18px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.36px !important',
        },
      },
      '& .MuiDivider-root': {
        backgroundColor: `${palette.background.border} !important`,
      },
      '& .MuiDivider-vertical': {
        backgroundColor: `${palette.background.border} !important`,
        width: '1px !important',
        height: '56px !important',
        alignSelf: 'center',
      },
      '& .contact-items-row': {
        justifyContent: 'center !important',
        gap: '48px',
        '@media(max-width: 960px)': {
          gap: '24px',
        },
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'NeueMontreal-Medium',
        fontWeight: 400,
      },
      '& .customAddMembersLink': {
        color: `${palette.text.primary} !important`,
      },
      '& .customPromoToggle': {
        color: `${palette.text.primary} !important`,
      },
    },

    '& .success-wrapper': {
      marginTop: 120,
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: `${palette.primary.light} !important`,
    },
    '& .mail-link': {
      color: palette.text.content,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
      backgroundColor: palette.primary.main,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      maxWidth: '598px',
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.background.border,
        color: palette.background.border,
        borderTopWidth: 2,
      },
      '& .MuiStepIcon-root': {
        color: 'transparent',
        width: 32,
        height: 32,
        borderColor: palette.primary.main,
        '&.MuiStepIcon-completed': {
          fill: `${palette.primary.main} !important`,
          color: palette.text.highlight,
          '& .MuiSvgIcon-root': {
            color: palette.primary.main,
          },
        },
        '&.MuiStepIcon-active': {
          fill: `${palette.primary.main} !important`,
          color: palette.text.highlight,
          '& .MuiSvgIcon-root': {
            color: palette.primary.main,
          },
          '& .MuiStepIcon-text': {
            fill: palette.text.highlight,
          },
        },
        '&:not(.MuiStepIcon-completed):not(.MuiStepIcon-active)': {
          '& .MuiSvgIcon-root': {
            color: 'transparent',
          },
          '& .MuiStepIcon-text': {
            fill: palette.primary.main,
          },
        },
      },
      '& .MuiStepLabel-label': {
        color: palette.text.primary,
        '&.MuiStepLabel-completed, &.MuiStepLabel-active': {
          color: palette.text.primary,
          fontWeight: 500,
        },
      },
    },

    '& .stepperContainer': {
      '@media(max-width: 900px)': {
        display: 'none',
      },
    },

    '& .stepperItems': {
      marginTop: 24,
    },

    '& .footer-wrapper': {
      backgroundColor: palette.background.footer,
      color: `${palette.text.highlight} !important`,
      paddingInline: '40px !important',
      '@media(max-width: 700px)': {
        paddingInline: '10px !important',
      },
      '& p, & span, & .MuiTypography-root': {
        color: `${palette.text.highlight} !important`,
      },
      '& a, & .footer-link, & .copyrights-footer-link, & .MuiButton-root, & .MuiLink-root': {
        color: `${palette.text.highlight} !important`,
      },
      '& .MuiButton-label': {
        color: `${palette.text.highlight} !important`,
      },
    },
  },

  /* CustomDrawer — Payment Details header (portals to body) */
  '.custom-drawer-wrapper .drawer-title-container': {
    backgroundColor: `${palette.background.footer} !important`,
    color: `${palette.text.highlight} !important`,
    '& .drawer-title': {
      color: `${palette.text.highlight} !important`,
    },
    '& .drawer-close-button': {
      color: `${palette.text.highlight} !important`,
    },
  },
};
